import { call, put, takeEvery } from 'redux-saga/effects';
import callApi from 'utils/callApi';
import { fetchAccountInformationSuccess } from 'redux/modules/account';
import { fetchAppInfoSuccess } from 'redux/modules/appInfo';

// Actions
export const CREATE_PATIENT_VITALS = 'CREATE_PATIENT_VITALS';
export const CREATE_PATIENT_VITALS_SUCCESS = 'CREATE_PATIENT_VITALS_SUCCESS';
export const CREATE_PATIENT_VITALS_FAIL = 'CREATE_PATIENT_VITALS_FAIL';
export const DELETE_PATIENT_VITALS = 'DELETE_PATIENT_VITALS';
export const DELETE_PATIENT_VITALS_SUCCESS = 'DELETE_PATIENT_VITALS_SUCCESS';
export const DELETE_PATIENT_VITALS_FAIL = 'DELETE_PATIENT_VITALS_FAIL';

// Reducer
export default function patientsVitalsReducer(state = {
  data: [], count: 0, loading: 0,
}, action) {
  const { type, payload } = action;
  switch (type) {
    case CREATE_PATIENT_VITALS_SUCCESS: {
      const newData = state.data.map((stateItem) => {
        if (stateItem['Record Number'] !== payload['Record Number']) {
          return stateItem;
        }
        const newVitals = [
          ...stateItem.Vitals.slice(0, stateItem.Vitals.length),
          payload.Vitals,
        ];
        return {
          ...stateItem,
          Vitals: newVitals,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case DELETE_PATIENT_VITALS_SUCCESS: {
      const newData = state.data.map((stateItem) => {
        if (stateItem['Record Number'] !== payload['Record Number']) {
          return stateItem;
        }
        const index = stateItem.Vitals.findIndex(item => item.ID === payload.ID);
        const newVitals = [
          ...stateItem.Vitals.slice(0, index),
          ...stateItem.Vitals.slice(index + 1),
        ];
        return {
          ...stateItem,
          Vitals: newVitals,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    default:
      return state;
  }
}

// Action Creators
export function createPatientVitals(payload) {
  return { type: CREATE_PATIENT_VITALS, payload };
}

export function createPatientVitalsSuccess(payload) {
  return { type: CREATE_PATIENT_VITALS_SUCCESS, payload };
}

export function createPatientVitalsFail(payload) {
  return { type: CREATE_PATIENT_VITALS_FAIL, payload };
}

export function deletePatientVitals(payload) {
  return { type: DELETE_PATIENT_VITALS, payload };
}

export function deletePatientVitalsSuccess(payload) {
  return { type: DELETE_PATIENT_VITALS_SUCCESS, payload };
}

export function deletePatientVitalsFail(payload) {
  return { type: DELETE_PATIENT_VITALS_FAIL, payload };
}

// Requests
export function requestCreatePatientVitals(payload) {
  return callApi('patient/vitals/', 'POST', payload);
}

export function requestDeletePatientVitals(payload) {
  return callApi(`patient/vitals/?id=${payload.ID}`, 'DELETE');
}

// Sagas
function* createPatientVitalsSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestCreatePatientVitals, values);
    yield put(createPatientVitalsSuccess({
      'Record Number': values['User Record Number'],
      Vitals: res.data,
    }));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(createPatientVitalsFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* deletePatientVitalsSaga(action) {
  try {
    const res = yield call(requestDeletePatientVitals, action.payload);
    yield put(deletePatientVitalsSuccess(action.payload));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    yield put(deletePatientVitalsFail(err.data));
  }
}

export function* patientsVitalsSaga() {
  yield takeEvery(CREATE_PATIENT_VITALS, createPatientVitalsSaga);
  yield takeEvery(DELETE_PATIENT_VITALS, deletePatientVitalsSaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/patientsVitals.js